import Table from "antd/lib/table";
import "antd/lib/table/style/css";

export default Table;
